import textServices from 'services/text-services'
import { NEIGHBARS_ASSETS } from '../constants'

const CALENDAR_ITEMS = [
  {
    key: 'convocatoria',
    icon: 'neighbars-calendario-icono_convocatoria-mobile.webp',
    title: textServices.findByText('neighbars/calendar/convocatoria/title', 'Convocatoria') as string,
    text: textServices.findByText(
      'neighbars/calendar/convocatoria/text',
      '20 de septiembre.'
    ) as string
  },
  {
    key: 'seleccion',
    icon: 'neighbars-calendario-icono_seleccion-mobile.webp',
    title: textServices.findByText('neighbars/calendar/seleccion/title', 'Selección') as string,
    text: textServices.findByText(
      'neighbars/calendar/seleccion/text',
      'Del 21 al 22 de septiembre.'
    ) as string
  },
  {
    key: 'ganadores',
    icon: 'neighbars-calendario-icono_ganadores-mobile.webp',
    title: textServices.findByText('neighbars/calendar/ganadores/title', 'Ganadores') as string,
    text: textServices.findByText('neighbars/calendar/ganadores/text', '23 de septiembre.') as string
  }
]

const CalendarSection = () => {
  return (
    <section className="neighbars__calendar">
      <h2 className="neighbars__calendar-title">
        {textServices.findByText('neighbars/calendar/title', 'Calendario')}
      </h2>
      <div className="neighbars__calendar-grid">
        {CALENDAR_ITEMS.map(({ key, icon, title, text }) => (
          <article key={key} className="neighbars__calendar-card">
            <img className="neighbars__calendar-icon" src={`${NEIGHBARS_ASSETS}/${icon}`} alt="" aria-hidden="true" />
            <h3 className="neighbars__calendar-card-title">{title}</h3>
            <p className="neighbars__calendar-card-text">{text}</p>
          </article>
        ))}
      </div>
      <p className="neighbars__calendar-legend">
        {textServices.findByText('neighbars/calendar/legend', 'VÁLIDO SOLO EN CDMX')}
      </p>
    </section>
  )
}

export default CalendarSection
